import React from 'react';
import { Link as RouterLink } from 'react-router-dom';
import Link from '@mui/material/Link';

import PropTypes from 'prop-types';
import stylesConfig from '../../../theme/config';

const styles = stylesConfig.links;

function InternalLink({
  to, text, style, theme, children, onClick,
}) {
  const themeStyles = styles[theme];

  return (
    <Link
      component={RouterLink}
      to={to}
      onClick={onClick}
      sx={{ ...themeStyles, ...style }}
    >
      {text}
      {children}
    </Link>
  );
}

InternalLink.defaultProps = {
  style: undefined,
  theme: '',
  onClick: () => {},
};

InternalLink.propTypes = {
  style: PropTypes.shape({}),
  theme: PropTypes.string,
  onClick: PropTypes.func,
};

export default InternalLink;
